import React, {useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import styles from './Profile.module.scss';
import {Form, Formik} from 'formik';
import * as Yup from 'yup';
import {Button, Input} from '../../../components';
import {
    emptyFn,
    formatRut,
    isNullOrUndefined,
    validateEmail,
    validateNativeRut,
    validateRequired
} from '../../../shared';
import {MailIcon} from '../../../components/style-guide/icons';
import PhoneInput from '../../../components/style-guide/form/phone-input/PhoneInput';

export const Profile = (props) => {
    const {onSubmit, userInfo} = props;  
    const formRef = useRef();
    const colStyle = "col-sm-12 col-md-4";
    
    useEffect(() => {
        if (!isNullOrUndefined(userInfo)){
            formRef.current.setFieldValue('phone', userInfo.phone ? '+' + userInfo.phone : '');
            formRef.current.setFieldValue('rut', formatRut(userInfo?.rut));
        }            
    }, [userInfo]);

    return (
        <div className="h-100 p-4">
            <p className={styles.title}>MI PERFIL</p>
            <Formik
                innerRef={formRef}
                initialValues={{
                    ...{
                        email: '',
                        name: '',
                        fatherLastName: '',
                        motherLastName: '',
                        phone: '',
                        rut: ''
                    },
                    ...userInfo
                }}
                validationSchema={
                    Yup.object().shape({
                        rut: validateNativeRut,
                        email: validateEmail,
                        name: Yup.lazy((value, context) => {
                            return validateRequired('El nombre es requerido.').name("El nombre no es válido.");
                        }),
                        fatherLastName: Yup.lazy((value, context) => {
                            return validateRequired('El apellido paterno es requerido.').name("El apellido paterno no es válido.");
                        }),
                        motherLastName: Yup.lazy((value, context) => {
                            return Yup.string().max(100, "La cantidad máxima de caracteres es 100.").name("El apellido materno no es válido.");
                        }),
                        phone: Yup.lazy((value, context) => {
                            return Yup.string().nullable().phone(context.parent.countryCode)
                        })
                    })
                }
                onSubmit={onSubmit}>
                {({
                      isValid,
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      isSubmitting,
                      setFieldValue
                  }) => (
                    <Form>
                        <div className="row">
                            <div className={colStyle}>
                                <Input
                                    disabled
                                    classNameInputPrefixIcon={styles.mailInput}
                                    prefixIcon={(<MailIcon fill="#9FA6B2"/>)} prefixTop={39} inputLeft={36}
                                    label="Correo Electrónico"
                                    name="email"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.email}
                                    error={errors.email && touched.email && errors.email}
                                />
                            </div>
                            <div className={colStyle}>
                                <Input
                                    required
                                    label="RUT"
                                    name="rut"
                                    onChange={handleChange}
                                    onBlur={event => {
                                        setFieldValue('rut', formatRut(values['rut']));
                                        return handleBlur(event);
                                    }}
                                    value={values.rut}
                                    error={errors.rut && touched.rut && errors.rut}
                                />
                            </div>
                            <div className={colStyle}>
                                <PhoneInput
                                    country={'cl'}
                                    label="Teléfono"
                                    name="phone"
                                    onChange={(v, phoneDetails) => {
                                        setFieldValue('phone', v, phoneDetails.countryCode);
                                        setFieldValue('countryCode', phoneDetails.countryCode.toUpperCase());
                                    }}
                                    onBlur={handleBlur}
                                    value={values.phone}
                                    error={errors.phone && touched.phone && errors.phone}
                                />
                            </div>
                            <div className={colStyle}>
                                <Input
                                    required
                                    label="Nombre(s)"
                                    name="name"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.name}
                                    error={errors.name && touched.name && errors.name}
                                />
                            </div>
                            <div className={colStyle}>
                                <Input
                                    required
                                    label="Apellido Paterno"
                                    name="fatherLastName"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.fatherLastName}
                                    error={errors.fatherLastName && touched.fatherLastName && errors.fatherLastName}
                                />
                            </div>
                            <div className={colStyle}>
                                <Input
                                    label="Apellido Materno"
                                    name="motherLastName"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.motherLastName}
                                    error={errors.motherLastName && touched.motherLastName && errors.motherLastName}
                                />
                            </div>
                        </div>
                        <div className={styles.buttonContainer}>
                            <Button type="submit" label="Guardar" disabled={isSubmitting}/>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

Profile.propTypes = {
    onSubmit: PropTypes.func,
    userInfo: PropTypes.object,
};

Profile.defaultProps = {
    onSubmit: emptyFn()
};

export default Profile;
